var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10378 30.4973H4.18692C3.52872 30.4973 3 31.026 3 31.6842V34.1876C3 34.8458 3.52872 35.3745 4.18692 35.3745H8.10378C8.76198 35.3745 9.2907 34.8458 9.2907 34.1876V31.6842C9.2907 31.026 8.76198 30.4973 8.10378 30.4973Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3246 23.0305H9.31223C9.32302 22.9657 9.3446 22.901 9.36618 22.8255L15.3871 6.60776C15.6785 5.83086 15.1066 5.0108 14.2757 5.0108H10.5207C10.0244 5.0108 9.58199 5.32372 9.40935 5.7877L3.08627 22.8363C3.03232 22.9657 3.01074 23.106 3.01074 23.2463V24.2174V28.1343C3.01074 28.7925 3.53946 29.3212 4.19767 29.3212H8.11452H28.3354C28.9936 29.3212 29.5223 28.7925 29.5223 28.1343V24.2174C29.5115 23.5592 28.9828 23.0305 28.3246 23.0305Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8962 23.0305H35.813C36.4712 23.0305 36.9999 23.5592 36.9999 24.2174V34.1875C36.9999 34.8458 36.4712 35.3745 35.813 35.3745H31.8962C31.2379 35.3745 30.7092 34.8458 30.7092 34.1875V24.2066C30.7092 23.5592 31.2379 23.0305 31.8962 23.0305Z",
    fill: "#00C6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9857 20.1926C34.4103 15.9089 30.5906 5.7769 30.5906 5.7769C30.4179 5.31292 29.9755 5 29.4792 5H29.4684H25.7242H18.0847C17.5884 5 17.146 5.31292 16.9733 5.7769L15.5166 9.69375C15.2253 10.4706 15.7972 11.2907 16.628 11.2907H26.3716C27.8175 15.1536 29.3065 19.0705 30.0079 21.0127C30.1806 21.4875 30.6337 21.8004 31.1301 21.8004H34.8635C35.6944 21.8004 36.277 20.9695 35.9857 20.1926Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbleLogo);
export default __webpack_public_path__ + "static/media/able-logo.4476f894ad4a5cf600810556c0e7971f.svg";
export { ForwardRef as ReactComponent };